// src/components/MobileModal.jsx
// Bottom-sheet wrapper around PostForm for mobile. Renders to a portal.
//
// Props: open, onClose, ...all PostForm props
//
// CLAUDE CODE: prepend `import React from "react";` etc, replace
// the `const PPIcons = window.PPIcons; ...` lines with real imports,
// and add `export default X;` at the bottom (replacing `window.X = X`).

import React, { useEffect as useEffect_MM } from "react";
import * as PPIcons from "./_icons";
import PinchIcon from "./PinchIcon";
import PostForm from "./PostForm";

function MobileModal({ open, onClose, ...formProps }) {
  useEffect_MM(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;
  return (
    <div className="pp-overlay" onClick={onClose}>
      <div className="pp-sheet" onClick={e => e.stopPropagation()}>
        <div className="pp-sheet-handle" />
        <div className="pp-sheet-head">
          <span className="pp-brand-mark" style={{ width: 24, height: 24, borderRadius: 6 }}>
            <PinchIcon size={14} />
          </span>
          <div>
            <div className="pp-sheet-title">New pinch point</div>
            <div className="pp-section-sub">Takes 30 seconds · we'll help you write it</div>
          </div>
          <button
            className="pp-icon-btn"
            style={{ marginLeft: "auto" }}
            aria-label="Close"
            onClick={onClose}
          >
            <PPIcons.IconX />
          </button>
        </div>
        <div className="pp-sheet-body">
          <PostForm {...formProps} variant="modal" />
        </div>
      </div>
    </div>
  );
}

export default MobileModal;
